import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    categories: [],
    loading: false,
};

const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        addCategory: (state, action) => {
            state.categories.push(action.payload);
        },
        removeCategory: (state, action) => {
            state.categories = state.categories.filter(category => category._id !== action.payload);
        },
        editCategory: (state, action) => {
            let categoryIndex = state.categories.findIndex((cate) => cate._id == action.payload._id)
            if (categoryIndex !== -1)
                state.categories[categoryIndex] = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const { setCategories, setLoading, addCategory, removeCategory, editCategory } = categorySlice.actions;
export const categoryReducers = categorySlice.reducer